import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { handleSelectRequest } from '../../ProceduresViewController';
import ProceduresCreatedView from './ProceduresCreatedView';
import { Creators as getProceduresCreatedActions } from '../../../../../domain/useCases/procedures/proceduresCreated/GetProceduresCreated/actions';
import { Creators as getYearsActions } from '../../../../../domain/useCases/procedures/proceduresCreated/getYearsOfProcedures/actions';
import XCheckpointManager from '../../../../../core/managers/xcheckpointManager';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const ProceduresCreatedController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const goToSelectRequest = handleSelectRequest();

  const { data: dataYears, selectedYear } = useSelector(
    (state: any) => state.yearsOfProcedures
  );

  const {
    onlyPage: singlePage,
    pagesArray,
    isLoading: isLoadingProcedures
  } = useSelector((state: any) => state.getProceduresCreated);

  const handlerBack = () => history.push('/tramites');

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-procedureCreated', 'procedure');
    dispatch(getYearsActions.getYearsOfProcedures());
  }, []);

  useEffect(() => {
    if (pagesArray && pagesArray?.length > 0) {
      XCheckpointManager.registerEnd('Historial de Trámites');
    }
  }, [pagesArray]);

  useEffect(() => {
    if (selectedYear) {
      XCheckpointManager.registerStart('Historial de Trámites');
      dispatch(getProceduresCreatedActions.getProceduresCreated(selectedYear));
    }
  }, [selectedYear]);

  const pickPage = (page: number) => {
    dispatch(getProceduresCreatedActions.selectPage(page));
  };
  const handleChangeSelectYear = (year: string) => {
    dispatch(getYearsActions.selectYear(year));
  };
  return (
    <ProceduresCreatedView
      isLoadingProcedures={isLoadingProcedures}
      years={dataYears}
      executeSelectRequest={goToSelectRequest.execute}
      handleChangeSelectYear={handleChangeSelectYear}
      selectedYear={selectedYear}
      totalPages={pagesArray}
      selectedPage={singlePage}
      pickPage={pickPage}
      handlerBack={handlerBack}
    />
  );
};

export default ProceduresCreatedController;
